import { useState, useEffect } from "react";
import { useForgotMutation } from "../../../../store/auth/usersApiSlice";

/* Step 1's rules. TRANSCRIBED from components/public/ResetPassword/Email.jsx. Two things happen here and both are kept exactly: 1. The link jump. On mount, if... */
export const forgotErrorMessage = (error) =>
  error?.data?.email?.[0] ||
  error?.data?.non_field_errors?.[0] ||
  "Went Something wrong!";

export const useForgotEmail = ({ onNext, onLinkedToken, initialEmail = "" }) => {
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState(null);
  const [forgot, { isLoading }] = useForgotMutation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userEmail = urlParams.get("email");
    const userToken = urlParams.get("token");
    if (userEmail && userToken) {
      setEmail(userEmail);
      onLinkedToken();
    }
    /* Transcribed dependency list: the live effect depends on the jump
       callback alone, so it re-runs if that identity changes and not when the
       typed address does. */
  }, [onLinkedToken]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await forgot({ email }).unwrap();
      /* Transcribed: the step only advances on a truthy body. A 200 with an
         empty payload leaves the user on this step rather than telling them an
         email is on the way that never was. */
      if (res) {
        onNext(email);
      }
    } catch (err) {
      setError(forgotErrorMessage(err));
    }
  };

  return { email, setEmail, error, isLoading, handleSubmit };
};

export default useForgotEmail;
